import { render } from "./AdvanceCarePlan.vue?vue&type=template&id=66fea48f&scoped=true&ts=true"
import script from "./AdvanceCarePlan.ts?vue&type=script&lang=ts&external"
export * from "./AdvanceCarePlan.ts?vue&type=script&lang=ts&external"

import "./AdvanceCarePlan.vue?vue&type=style&index=0&id=66fea48f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fea48f"]])

export default __exports__